import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DepartmentTabs } from "@/components/DepartmentTabs";

export const CalendarToolbar = ({ label, view, setView, onPrev, onNext, onToday, dept, setDept, showDept }) => (
  <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 mb-4">
    <div className="flex items-center gap-2">
      <Button variant="outline" size="icon" className="rounded-full" onClick={onPrev} data-testid="calendar-prev-btn"><ChevronLeft className="w-4 h-4" /></Button>
      <Button variant="outline" size="icon" className="rounded-full" onClick={onNext} data-testid="calendar-next-btn"><ChevronRight className="w-4 h-4" /></Button>
      <Button variant="ghost" className="rounded-full" onClick={onToday} data-testid="calendar-today-btn">Today</Button>
      <h2 className="text-lg sm:text-xl font-bold text-slate-800 ml-1" data-testid="calendar-range-label">{label}</h2>
    </div>
    <div className="flex flex-wrap items-center gap-2">
      {showDept && <DepartmentTabs value={dept} onChange={setDept} prefix="dept-filter" />}
      <Tabs value={view} onValueChange={setView}>
        <TabsList className="rounded-full">
          <TabsTrigger value="day" className="rounded-full" data-testid="view-toggle-day">Day</TabsTrigger>
          <TabsTrigger value="week" className="rounded-full" data-testid="view-toggle-week">Week</TabsTrigger>
          <TabsTrigger value="month" className="rounded-full" data-testid="view-toggle-month">Month</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  </div>
);
